import { render } from "./ItemButton.vue?vue&type=template&id=7948302b"
import script from "./ItemButton.vue?vue&type=script&lang=js"
export * from "./ItemButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__